export function mapBookingRiderFilterResult(booking) {
  return {
    ...booking,
    client_fullname:
      booking.client_fullname ||
      [booking.client_name, booking.client_lastname].filter(Boolean).join(" "),
    driver_fullname:
      booking.driver_fullname ||
      [booking.driver_name, booking.driver_lastname].filter(Boolean).join(" "),
  };
}
